import createIcon from '../../createIcon';

/**
 * @component @name SettingsBluetooth
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNjQ0NSAyNEgxMy42NDQ1VjIySDExLjY0NDVWMjRaTTcuNjQ0NTMgMjRIOS42NDQ1M1YyMkg3LjY0NDUzVjI0Wk0xNS42NDQ1IDI0SDE3LjY0NDVWMjJIMTUuNjQ0NVYyNFpNMTguMzU0NSA1LjcxTDEyLjY0NDUgMEgxMS42NDQ1VjcuNTlMNy4wNTQ1MyAzTDUuNjQ0NTMgNC40MUwxMS4yMzQ1IDEwTDUuNjQ0NTMgMTUuNTlMNy4wNTQ1MyAxN0wxMS42NDQ1IDEyLjQxVjIwSDEyLjY0NDVMMTguMzU0NSAxNC4yOUwxNC4wNTQ1IDEwTDE4LjM1NDUgNS43MVpNMTMuNjQ0NSAzLjgzTDE1LjUyNDUgNS43MUwxMy42NDQ1IDcuNTlWMy44M1pNMTUuNTI0NSAxNC4yOUwxMy42NDQ1IDE2LjE3VjEyLjQxTDE1LjUyNDUgMTQuMjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsBluetooth = createIcon('SettingsBluetooth', [
  [
    'path',
    {
      d: 'M11.6445 24H13.6445V22H11.6445V24ZM7.64453 24H9.64453V22H7.64453V24ZM15.6445 24H17.6445V22H15.6445V24ZM18.3545 5.71L12.6445 0H11.6445V7.59L7.05453 3L5.64453 4.41L11.2345 10L5.64453 15.59L7.05453 17L11.6445 12.41V20H12.6445L18.3545 14.29L14.0545 10L18.3545 5.71ZM13.6445 3.83L15.5245 5.71L13.6445 7.59V3.83ZM15.5245 14.29L13.6445 16.17V12.41L15.5245 14.29Z',
      key: '3f10y1',
    },
  ],
]);

export default SettingsBluetooth;
